import Vue from 'vue'

export const UPDATE_CRUMBS = (state, crumbs) => {
  state.crumbs = crumbs
}

export const ISLOADING = (state, value) => {
  console.log(`loading: ${value}`)
  state.isLoading = value
}



// WEBPACK FOOTER //
// ./src/store/mutations.js